import * as Immutable from 'immutable';
import { handleActions } from 'redux-actions';

import { LeaderboardActionType } from './LeaderboardReducer.types';

const initialState = Immutable.List();

export const LeaderboardReducer = handleActions<any>(
  {
    GET_CONSULTANTS_LEADERBOARD_SUCCESS: (_: any, action: LeaderboardActionType) => Immutable.fromJS(action.payload.results),
    AUTHENTICATION_LOGOUT: () => initialState,
  },
  initialState
);
